import React from 'react';
import { Button, Grid, Header } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import {
  ItemEnum,
  FilterEnum,
  ItemStorageLocationEnum,
} from 'Common/FieldEnum';
import { SelectField, TextLabelField } from 'Common/SemanticWrapper';
import { ItemStorageLocationInfoContainer } from '../containers/ItemStorageLocationInfo';
import { makeOptionsData } from 'Common/FormHelper';

const SetStorageLocationComponent = props => {
  const {
    itemStorageLocationData,
    storageLocationData,
    fetchingItemStorageLocation,
    handleApplyToAll,
    gridStorageLocationDataLoading,
    gridStorageDropDownData,
  } = props;
  const storageLocationOptions = makeOptionsData(storageLocationData);

  return (
    <Grid>
      <Grid.Row columns={16}>
        <Grid.Column width={16}>
          <Header as="h4" className={'text-orange'}>
            <Field
              name={ItemEnum.ItemCode}
              component={TextLabelField}
              disabled={true}
            />
            <span>&nbsp;:</span>
            <Field
              name={ItemEnum.ItemDescription}
              component={TextLabelField}
              disabled={true}
            />
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row cloumns={3}>
        <Grid.Column width={4}>
          <Field
            component={SelectField}
            name={FilterEnum.GroupId_Location}
            options={storageLocationOptions}
            type={'text'}
            label={'Default Storage Location'}
          />
        </Grid.Column>
        <Grid.Column
          width={4}
          style={{
            marginTop: 44,
          }}
        >
          <Button
            content="Apply To All"
            onClick={handleApplyToAll}
            type={'button'}
          />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column>
          <Field
            component={ItemStorageLocationInfoContainer}
            name={ItemStorageLocationEnum.ItemStorageLocationInfo}
            {...{
              dataSource:
                itemStorageLocationData &&
                itemStorageLocationData.SiteStorageLocList
                  ? itemStorageLocationData.SiteStorageLocList
                  : [],
              fetchingItemStorageLocation,
              gridStorageDropDownData: makeOptionsData(gridStorageDropDownData),
              gridStorageLocationDataLoading,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

SetStorageLocationComponent.propTypes = {
  itemStorageLocationData: PropTypes.object,
  storageLocationData: PropTypes.array.isRequired,
  fetchingItemStorageLocation: PropTypes.bool,
  handleApplyToAll: PropTypes.func,
  gridStorageLocationDataLoading: PropTypes.bool,
  gridStorageDropDownData: PropTypes.array.isRequired,
};

export default SetStorageLocationComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/SetStorageLocation.js